/**
 * Internal dependencies
 */
import { dispatchProductsAddedToCartEvent } from './events';

/* eslint-disable */
const getItems = () =>
	( ( window as any ).wp?.data?.select( 'wc/store/cart' )?.getCartData?.()
		?.items ?? [] ) as ReadonlyArray< { id: number } >;
/* eslint-enable */

let previousItems = getItems();
window.addEventListener( 'wc-blocks_added_to_cart', () => {
	const currentItems = getItems();
	const addedProducts = currentItems.filter(
		( p ) => ! previousItems.some( ( pp ) => pp.id === p.id )
	);
	previousItems = currentItems;
	dispatchProductsAddedToCartEvent( addedProducts );
} );
